import { createReactComponent } from './react-component-lib';
export const DhlAccordion = createReactComponent('dhl-accordion');
export const DhlAlert = createReactComponent('dhl-alert');
export const DhlAutocompleteField = createReactComponent('dhl-autocomplete-field');
export const DhlBackToTop = createReactComponent('dhl-back-to-top');
export const DhlButton = createReactComponent('dhl-button');
export const DhlButtonGroup = createReactComponent('dhl-button-group');
export const DhlCard = createReactComponent('dhl-card');
export const DhlCenter = createReactComponent('dhl-center');
export const DhlCheckbox = createReactComponent('dhl-checkbox');
export const DhlCheckboxGroup = createReactComponent('dhl-checkbox-group');
export const DhlChip = createReactComponent('dhl-chip');
export const DhlChipContainer = createReactComponent('dhl-chip-container');
export const DhlCopyText = createReactComponent('dhl-copy-text');
export const DhlCounter = createReactComponent('dhl-counter');
export const DhlDatePicker = createReactComponent('dhl-date-picker');
export const DhlDateRangePicker = createReactComponent('dhl-date-range-picker');
export const DhlDropdown = createReactComponent('dhl-dropdown');
export const DhlFlex = createReactComponent('dhl-flex');
export const DhlFooter = createReactComponent('dhl-footer');
export const DhlGlobalValidation = createReactComponent('dhl-global-validation');
export const DhlGridCell = createReactComponent('dhl-grid-cell');
export const DhlGridContainer = createReactComponent('dhl-grid-container');
export const DhlHeadline = createReactComponent('dhl-headline');
export const DhlHstack = createReactComponent('dhl-hstack');
export const DhlIcon = createReactComponent('dhl-icon');
export const DhlIconWrapper = createReactComponent('dhl-icon-wrapper');
export const DhlIllustratedValidation = createReactComponent('dhl-illustrated-validation');
export const DhlImage = createReactComponent('dhl-image');
export const DhlIndicatorStep = createReactComponent('dhl-indicator-step');
export const DhlInputField = createReactComponent('dhl-input-field');
export const DhlInputGroup = createReactComponent('dhl-input-group');
export const DhlLabel = createReactComponent('dhl-label');
export const DhlLink = createReactComponent('dhl-link');
export const DhlList = createReactComponent('dhl-list');
export const DhlListItem = createReactComponent('dhl-list-item');
export const DhlLoader = createReactComponent('dhl-loader');
export const DhlModal = createReactComponent('dhl-modal');
export const DhlNavbar = createReactComponent('dhl-navbar');
export const DhlPageHeadline = createReactComponent('dhl-page-headline');
export const DhlPanel = createReactComponent('dhl-panel');
export const DhlPlaceholder = createReactComponent('dhl-placeholder');
export const DhlPopover = createReactComponent('dhl-popover');
export const DhlProgressIndicator = createReactComponent('dhl-progress-indicator');
export const DhlRadioButton = createReactComponent('dhl-radio-button');
export const DhlRadioButtonGroup = createReactComponent('dhl-radio-button-group');
export const DhlReadMore = createReactComponent('dhl-read-more');
export const DhlSelect = createReactComponent('dhl-select');
export const DhlSelectableCard = createReactComponent('dhl-selectable-card');
export const DhlSlider = createReactComponent('dhl-slider');
export const DhlSpacer = createReactComponent('dhl-spacer');
export const DhlStack = createReactComponent('dhl-stack');
export const DhlStage = createReactComponent('dhl-stage');
export const DhlStageActionBox = createReactComponent('dhl-stage-action-box');
export const DhlStageIntro = createReactComponent('dhl-stage-intro');
export const DhlStageNumbers = createReactComponent('dhl-stage-numbers');
export const DhlStageTiles = createReactComponent('dhl-stage-tiles');
export const DhlStageTracking = createReactComponent('dhl-stage-tracking');
export const DhlSwitch = createReactComponent('dhl-switch');
export const DhlTable = createReactComponent('dhl-table');
export const DhlTabs = createReactComponent('dhl-tabs');
export const DhlTelemetry = createReactComponent('dhl-telemetry');
export const DhlText = createReactComponent('dhl-text');
export const DhlTextAreaField = createReactComponent('dhl-text-area-field');
export const DhlTextSrOnly = createReactComponent('dhl-text-sr-only');
export const DhlThemeSwitch = createReactComponent('dhl-theme-switch');
export const DhlTrackingBar = createReactComponent('dhl-tracking-bar');
export const DhlValidationFeedback = createReactComponent('dhl-validation-feedback');
export const DhlValidationFeedbackIcon = createReactComponent('dhl-validation-feedback-icon');
export const DhlValidationMessage = createReactComponent('dhl-validation-message');
export const DhlVstack = createReactComponent('dhl-vstack');
export const DhlWrap = createReactComponent('dhl-wrap');
//# sourceMappingURL=index.js.map